import { useQuery } from 'react-query';
import axios from 'axios';
import { AuthContext } from '../Context/AuthContext';
import { useContext } from 'react';


const fetchCategories = async (token) => {
  const { data } = await axios.get(`${process.env.REACT_APP_SERVER_URL}/data/readVesselCategories`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  
  return data; 
};


const useCategories = () => {
  const { token } = useContext(AuthContext);

  return useQuery(['categories'], () => fetchCategories(token), {
    enabled: !!token, 
  });
};

export default useCategories;
